// REACT
import React from "react";

// MATERIAL-UI
import { Paper, Typography, Modal, Box } from "@mui/material";

// ASSETS
import { QrModalStyles } from "src/components/wallets/common/styles/QrModal.styles";

const COPIED_ADDRESS = "Address copied successfully to clipboard";

interface CopyAddressProps {
  open: boolean;
  text?: string;
  onClose?: (event: React.MouseEvent<HTMLDivElement | HTMLAnchorElement>) => void;
}

const CopyAddress = (props: CopyAddressProps) => {
  const classes = QrModalStyles();

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Paper className={classes.copy}>
        <Box mx={3} my={3}>
          <Typography style={{ textAlign: "center" }}>{props.text || COPIED_ADDRESS}</Typography>
        </Box>
      </Paper>
    </Modal>
  );
};

export default CopyAddress;
